<div class="row">
  <div class="l-pt-7 l-pb-7">
    <div class="cds-h2-demibold">{{ 'common.error2' | lang }}</div>
    <div class="cds-h2-demibold">{{ 'common.error-body' | lang }}</div>
  </div>
</div>
<div class="row">
  <div class="cds-h3-light">
    <cds-button (click)="toHome()">{{ 'common.backToHome' | lang }}</cds-button>
  </div>
</div>
